import { HOST } from "common-import/constants";
import { observable, autorun, computed } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./Contractor.API";
import _ from "lodash";

const PERSIST_STORE_ITEM = {
  
}

class ContractorStore {
  @observable listApproved = [];

  @observable listNotApproved = [];

  @observable currentContractor = {};

  @computed get allListContractor() {
    return [...this.listApproved, ...this.listNotApproved];
  }

  setProp = (prop, value) => { this[prop] = value  }
  
  getListApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 1,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  }

  getListNotApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 0,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  }

  getListNotApprovedUpdate = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 3,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  }

  search = async (name, approved) => {
    let res = await api.adminList({
      "name": name,
      "orderBy": "updatedAt",
	    "orderType": "DESC",
	    "approved": approved
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };

    switch(approved) {
      case 1: this.listApproved = json.data; break;
      case 0: this.listNotApproved = json.data; break;
      case 3: this.listNotApproved = json.data; break;
    }
    return { status: true };
  }

  setCurrentContractor = id => {
    let current = this.allListContractor.find(val => val.id == id);
    if(current == undefined) return {};
    this.currentContractor = current;
    return current;
  }

  update = async data => {
    const { id } = this.currentContractor;
    if(!id) return;
    let res = await api.update(id, data);
    let json = await res.json();
    return json;
  }

  create = async data => {
    let res = await api.create(data);
    let json = await res.json();
    return json;
  }

  approve = async ({id, approved}) => {
    let res = await api.approve({id, approved: approved ? 1 : 0});
    let json = await res.json();
    // if(!json.error) 
    return json;
  }

  updateHouseLink = async (data) => {
    let res = await api.updateHouseLink(data);
    let json = await res.json();
    return json;
  }
}

const contractorStore = new ContractorStore();

export default contractorStore;


// WEBPACK FOOTER //
// ./src/services/contractor/Contractor.Store.js